/*=========================================================================================
  File Name: moduleCommandeFourn.js
  Description: CommandeFour Module
  ----------------------------------------------------------------------------------------
==========================================================================================*/


import state from './moduleCommandeState.js'
import mutations from './moduleCommandeFournMutations.js'
import actions from './moduleCommandeFournActions.js'
import getters from './moduleCommandeFournGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

